import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import {
    Menu,
    MenuHandler,
    MenuList
} from "@material-tailwind/react";
import ToggleIcon from '../../admin/toggleCard/ToggleIcon'

function MenuInfoHospital() {
    const user = JSON.parse(localStorage.getItem('user'))
    const navigate = useNavigate()
    const [toggle, setToggle] = useState(false)

    return (
        <Menu open={toggle}>
            <MenuHandler onClick={() => { setToggle(!toggle) }}>
                <button className="flex h-[80px] items-center lg:mr-4 sm:mr-0 px-3 border-l hover:drop-shadow-sm bg-[#807a95]">
                    <img className={user?.profile_image ? "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px] rounded-full" : "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px]"} src={user?.profile_image ? user?.profile_image : require('../../../asset/icon/iconuser.svg').default} alt="iconuser" />
                    <p className="text-[#FFFFFF] text-lg font-medium px-3 lg:text-sm">{user?.fname + ' ' + user?.lname}</p>
                    <ToggleIcon toggleCards onToggle={() => { setToggle(!toggle) }} toggleStatus={toggle} />
                </button>
            </MenuHandler>
            <MenuList dismiss className="flex flex-col items-center w-80 rounded-3xl">
                <img className={user?.profile_image ? "w-[48px] h-[48px] rounded-full my-2" : "w-[48px] h-[48px] my-2"} src={user?.profile_image ? user?.profile_image  : require('../../../asset/icon/iconuser.svg').default} alt="" />
                <p className="text-[#FFFFFF] text-lg">{user?.fname + ' ' + user?.lname}</p>
                <button onClick={() => { navigate('/hospital/ManageInfoHospital') }} className="button-theme-pg flex justify-center items-center bg-[#FF9768] w-11/12 mt-6 rounded-full h-12 hover:ring-2 hover:ring-[#FF9768]">
                    <p className="text-white text-base">จัดการข้อมูลส่วนตัว</p>
                </button>
                <button onClick={() => { navigate('/hospital/changePassword') }} className="button-theme-pg flex justify-center items-center bg-[#FF9768] w-11/12 mt-2 rounded-full h-12 hover:ring-2 hover:ring-[#FF9768]">
                    <p className="text-white text-base">เปลี่ยนรหัสผ่าน</p>
                </button>
                <button
                    onClick={() => {
                        localStorage.clear()
                        navigate('/login')
                    }}
                    className="button-theme-pg flex justify-center items-center bg-white w-11/12 mt-8 rounded-full h-12 ring-1 ring-[#FF9768]">
                    <img src={require("../../../asset/icon/logout.svg").default} alt="" className="mr-2" />
                    <p className="text-[#FF9768] text-base">ออกจากระบบ</p>
                </button>
            </MenuList>
        </Menu>
    )
}
export default MenuInfoHospital